<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Cod.Tipo Lançamento', 'Quantidade Lançamento', 'Valor Lançamento (Débito)', 'Valor Lançamento (Credito)', 'Período Movimento']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="parseInt(obj.codTipoLancamento).toString()" />
        <TableColumn :IsText="true" :status="1" :value="obj.quantidadeLancamento ? obj.quantidadeLancamento.toString() : '0'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorLancamentoDebito ? formatValue(obj.valorLancamentoDebito) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorLancamentoCredito ? formatValue(obj.valorLancamentoCredito) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.periodoMovimento ? obj.periodoMovimento.toString() : ''" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import BankCheckRepository from '@/shared/http/repositories/business/bankcheck.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'BankCheck',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadBankCheck(this.document)
      }
    },
    onLoadBankCheck (document) {
      loading.push()
      this.document = document
      BankCheckRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    formatPeriod (value) {
      let result
      if (value) {
        result = value.substring(5, 7) + '/' + value.substring(0, 4)
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/bankcheck.vue